<div class="bg-white" [class]="state.tabCommonClasses()">
  <div
    class="flex h-full transition-opacity duration-100"
    [class.opacity-0]="isMinimized()"
    [class.hidden]="isHidden()"
  >
    <div class="flex flex-col flex-1 border-gray-200">
      <div [class]="state.tabHeaderClasses" class="px-4">
        <h3 class="flex items-center gap-2 md:gap-4"></h3>
        <div class="flex items-center gap-1">
          @if (remoteAudioTrack()) {
            <mib-button
              theme="secondary"
              mode="flat"
              size="medium"
              [attr.aria-label]="isMuted() ? 'Unmute sound' : 'Mute sound'"
              [attr.aria-pressed]="!isMuted()"
              (click)="toggleMute()"
            >
              <svg mib-audio-icon></svg>
              {{ isMuted() ? 'Unmute sound' : 'Mute sound' }}
            </mib-button>
          }
          <mib-button
            class="max-md:hidden"
            theme="secondary"
            mode="flat"
            size="medium"
            iconOnly
            mibTooltip="Minimize"
            mibTooltipShowDelay="500"
            (click)="toggleTab()"
          >
            <svg mib-chevron-left-icon></svg>
          </mib-button>
        </div>
      </div>
      <div class="block w-full shrink min-h-0 bg-gray-950">
        <video
          #previewVideo
          autoplay
          playsinline
          muted
          aria-label="Live session video"
          class="w-full h-full object-contain"
        ></video>
        <audio #audioEl autoplay aria-hidden="true"></audio>
      </div>
    </div>
  </div>
</div>
